import { render } from "./InHouseIndex.vue?vue&type=template&id=b0f024f8&scoped=true"
import script from "./InHouseIndex.vue?vue&type=script&lang=js"
export * from "./InHouseIndex.vue?vue&type=script&lang=js"

import "./InHouseIndex.vue?vue&type=style&index=0&id=b0f024f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0f024f8"]])

export default __exports__